/**
 * File generated by js-routes 2.2.7
 * Based on Rails 7.1.5.1 routes of Polaris::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /activations/callback/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activation_callback_url = /*#__PURE__*/ __jsr.r({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activations"],[2,[7,"/"],[2,[6,"callback"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /activations/callback/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activation_callback_path = /*#__PURE__*/ __jsr.r({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activations"],[2,[7,"/"],[2,[6,"callback"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /activations/initiate/:type(/:id)(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activation_initiate_url = /*#__PURE__*/ __jsr.r({"type":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"activations"],[2,[7,"/"],[2,[6,"initiate"],[2,[7,"/"],[2,[3,"type"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /activations/initiate/:type(/:id)(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activation_initiate_path = /*#__PURE__*/ __jsr.r({"type":{"r":true},"id":{},"format":{}}, [2,[7,"/"],[2,[6,"activations"],[2,[7,"/"],[2,[6,"initiate"],[2,[7,"/"],[2,[3,"type"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /activation_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activation_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /activation_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activation_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai_text_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_text_templates_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai_text_templates"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ai_text_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ai_text_templates_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai_text_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_companies_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_companies_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_brand_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_brand_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_brands_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_brands_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/lumina_videos/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_lumina_video_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"lumina_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/lumina_videos/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_lumina_video_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"lumina_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/lumina_videos(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_lumina_videos_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"lumina_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/lumina_videos(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_lumina_videos_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"lumina_videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/social_profile_metric_entry_states(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_social_profile_metric_entry_states_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"social_profile_metric_entry_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/social_profile_metric_entry_states(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_company_social_profile_metric_entry_states_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"social_profile_metric_entry_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_publication_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_publication_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/publications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_publications_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/publications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_publications_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/social_platforms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_social_platforms_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"social_platforms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/social_platforms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_social_platforms_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"social_platforms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassador_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassador_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_dashboard_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_dashboard_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassador_invite/:company_id/ambassadors/onboardings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_onboarding_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ambassador_invite"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassador_invite/:company_id/ambassadors/onboardings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_onboarding_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ambassador_invite"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"onboardings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassador_invite/:company_id/ambassadors/onboardings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_onboardings_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ambassador_invite"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"onboardings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassador_invite/:company_id/ambassadors/onboardings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_onboardings_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ambassador_invite"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"onboardings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_passwords_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_passwords_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_root_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_root_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_social_profile_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_social_profile_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_users_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadors_users_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/activation_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_activation_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/activation_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_activation_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/atses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_atses_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"atses"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/atses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_atses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"atses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/activation_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_activation_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/activation_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_activation_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/activation_invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_activation_invitations_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/activation_invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_activation_invitations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/ambassadors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_ambassadors_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"ambassadors"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/ambassadors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_ambassadors_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"ambassadors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets/:asset_id/publications(.:format)
 * @param {any} asset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_publications_url = /*#__PURE__*/ __jsr.r({"asset_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets/:asset_id/publications(.:format)
 * @param {any} asset_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_publications_path = /*#__PURE__*/ __jsr.r({"asset_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"asset_id"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/asset_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"asset_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/asset_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"asset_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/asset_sources/:asset_source_id/asset_source_contents(.:format)
 * @param {any} asset_source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_source_contents_url = /*#__PURE__*/ __jsr.r({"asset_source_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"asset_sources"],[2,[7,"/"],[2,[3,"asset_source_id"],[2,[7,"/"],[2,[6,"asset_source_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/asset_sources/:asset_source_id/asset_source_contents(.:format)
 * @param {any} asset_source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_source_contents_path = /*#__PURE__*/ __jsr.r({"asset_source_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"asset_sources"],[2,[7,"/"],[2,[3,"asset_source_id"],[2,[7,"/"],[2,[6,"asset_source_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/asset_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_sources_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"asset_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/asset_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_asset_sources_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"asset_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_assets_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_assets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/async_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_async_task_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"async_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/async_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_async_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"async_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/async_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_async_tasks_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"async_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/async_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_async_tasks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"async_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/brands/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_brand_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/brands/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_brand_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/brands(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_brands_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/brands(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_brands_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaign_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns/:campaign_id/assets(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaign_assets_url = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns/:campaign_id/assets(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaign_assets_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns/:campaign_id/publications(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaign_publications_url = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns/:campaign_id/publications(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaign_publications_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"publications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaigns_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_company_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"company"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_company_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"company"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/dashboard_stats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_dashboard_stats_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"dashboard_stats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/dashboard_stats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_dashboard_stats_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"dashboard_stats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/dashboard_tips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_dashboard_tips_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"dashboard_tips"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/dashboard_tips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_dashboard_tips_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"dashboard_tips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/employer_brand_campaigns/:campaign_id/post_previews(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_employer_brand_campaign_post_previews_url = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"employer_brand_campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"post_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/employer_brand_campaigns/:campaign_id/post_previews(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_employer_brand_campaign_post_previews_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"employer_brand_campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"post_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/event_day_rollups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_event_day_rollups_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"event_day_rollups"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/event_day_rollups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_event_day_rollups_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"event_day_rollups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/future_publishing_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_future_publishing_events_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"future_publishing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/future_publishing_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_future_publishing_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"future_publishing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/ingestion_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_ingestion_runs_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"ingestion_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/ingestion_runs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_ingestion_runs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"ingestion_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/integration_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_integration_requests_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"integration_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/integration_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_integration_requests_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"integration_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_map_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_map_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_maps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_maps_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_maps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_maps_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_postings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_posting_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_postings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_posting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_posting_metrics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_posting_metric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_posting_metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_posting_metrics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_posting_metric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_posting_metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_postings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_postings_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_postings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_postings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sharing_campaigns/:campaign_id/job_postings(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_sharing_campaign_job_postings_url = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sharing_campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sharing_campaigns/:campaign_id/job_postings(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_sharing_campaign_job_postings_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sharing_campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sharing_campaigns/:campaign_id/post_previews(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_sharing_campaign_post_previews_url = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sharing_campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"post_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sharing_campaigns/:campaign_id/post_previews(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_sharing_campaign_post_previews_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sharing_campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"post_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_sources_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_job_sources_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/lumina_video_imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_lumina_video_import_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"lumina_video_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/lumina_video_imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_lumina_video_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"lumina_video_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/lumina_video_imports/:lumina_video_import_id/post_previews(.:format)
 * @param {any} lumina_video_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_lumina_video_import_post_previews_url = /*#__PURE__*/ __jsr.r({"lumina_video_import_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"lumina_video_imports"],[2,[7,"/"],[2,[3,"lumina_video_import_id"],[2,[7,"/"],[2,[6,"post_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/lumina_video_imports/:lumina_video_import_id/post_previews(.:format)
 * @param {any} lumina_video_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_lumina_video_import_post_previews_path = /*#__PURE__*/ __jsr.r({"lumina_video_import_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"lumina_video_imports"],[2,[7,"/"],[2,[3,"lumina_video_import_id"],[2,[7,"/"],[2,[6,"post_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/lumina_video_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_lumina_video_imports_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"lumina_video_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/lumina_video_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_lumina_video_imports_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"lumina_video_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/metrics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_metric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/metrics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_metric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_passwords_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/passwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_passwords_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"passwords"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/past_publishing_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_past_publishing_events_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"past_publishing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/past_publishing_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_past_publishing_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"past_publishing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_post_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_posts_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts_for_publishing_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_posts_for_publishing_events_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts_for_publishing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts_for_publishing_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_posts_for_publishing_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts_for_publishing_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/publication_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_publication_schedule_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/publication_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_publication_schedule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/publication_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_publication_schedules_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/publication_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_publication_schedules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_account_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_accounts_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_accounts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profile_group_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_group_schedule_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profile_group_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_group_schedule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profile_group_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_group_schedules_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profile_group_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_group_schedules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profile_groups/:social_profile_group_id/social_profiles(.:format)
 * @param {any} social_profile_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_group_social_profiles_url = /*#__PURE__*/ __jsr.r({"social_profile_group_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_groups"],[2,[7,"/"],[2,[3,"social_profile_group_id"],[2,[7,"/"],[2,[6,"social_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profile_groups/:social_profile_group_id/social_profiles(.:format)
 * @param {any} social_profile_group_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_group_social_profiles_path = /*#__PURE__*/ __jsr.r({"social_profile_group_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_groups"],[2,[7,"/"],[2,[3,"social_profile_group_id"],[2,[7,"/"],[2,[6,"social_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profile_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_groups_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profile_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profile_groups_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profiles_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_social_profiles_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/source_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_source_code_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/source_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_source_code_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/source_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_source_codes_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/source_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_source_codes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tag_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/taggable/job_postings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_taggable_job_postings_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"taggable"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/taggable/job_postings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_taggable_job_postings_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"taggable"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tagging_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tagging_rules_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tagging_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tagging_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tagging_rules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tagging_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tags_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tags_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/topic_post_ai_prompts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_topic_post_ai_prompt_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"topic_post_ai_prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/topic_post_ai_prompts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_topic_post_ai_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"topic_post_ai_prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/topic_post_ai_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_topic_post_ai_prompts_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"topic_post_ai_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/topic_post_ai_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_topic_post_ai_prompts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"topic_post_ai_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/topic_tags/:topic_tag_id/topic_post_ai_prompt(.:format)
 * @param {any} topic_tag_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_topic_tag_topic_post_ai_prompt_url = /*#__PURE__*/ __jsr.r({"topic_tag_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"topic_tags"],[2,[7,"/"],[2,[3,"topic_tag_id"],[2,[7,"/"],[2,[6,"topic_post_ai_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/topic_tags/:topic_tag_id/topic_post_ai_prompt(.:format)
 * @param {any} topic_tag_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_topic_tag_topic_post_ai_prompt_path = /*#__PURE__*/ __jsr.r({"topic_tag_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"topic_tags"],[2,[7,"/"],[2,[3,"topic_tag_id"],[2,[7,"/"],[2,[6,"topic_post_ai_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tracking_pixels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tracking_pixel_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tracking_pixels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tracking_pixels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tracking_pixel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tracking_pixels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tracking_pixels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tracking_pixels_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tracking_pixels"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tracking_pixels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_tracking_pixels_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tracking_pixels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_users_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clients_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/companies/:company_id/job_categories(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_job_categories_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/companies/:company_id/job_categories(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_job_categories_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/companies/:company_id/job_postings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_job_posting_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/companies/:company_id/job_postings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_job_posting_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/companies/:company_id/job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_job_postings_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/companies/:company_id/job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_job_postings_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/companies/:company_id/visual_job_postings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_visual_job_posting_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"visual_job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/companies/:company_id/visual_job_postings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_visual_job_posting_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"visual_job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/companies/:company_id/visual_job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_visual_job_postings_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"visual_job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/companies/:company_id/visual_job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_company_visual_job_postings_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"visual_job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_countries_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/countries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_countries_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"countries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_industries_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_industries_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/brands(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_brands_url = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/brands(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_brands_path = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/job_categories(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_job_categories_url = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"job_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/job_categories(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_job_categories_path = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"job_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/job_postings/:id(.:format)
 * @param {any} job_map_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_job_posting_url = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/job_postings/:id(.:format)
 * @param {any} job_map_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_job_posting_path = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/job_postings(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_job_postings_url = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/job_postings(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_job_postings_path = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/markers(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_markers_url = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"markers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/job_maps/:job_map_id/markers(.:format)
 * @param {any} job_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_job_map_markers_path = /*#__PURE__*/ __jsr.r({"job_map_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"job_map_id"],[2,[7,"/"],[2,[6,"markers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/js_tracking_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_js_tracking_events_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"js_tracking_events"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/js_tracking_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_js_tracking_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"js_tracking_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_social_account_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_social_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/social_platforms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_social_platforms_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"social_platforms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/social_platforms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_social_platforms_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"social_platforms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/tracking_params_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tracking_params_events_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tracking_params_events"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/tracking_params_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tracking_params_events_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tracking_params_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reauthorize_social_profiles/:social_profile_id/:user_id/:id(.:format)
 * @param {any} social_profile_id
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_social_profile_url = /*#__PURE__*/ __jsr.r({"social_profile_id":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reauthorize_social_profiles"],[2,[7,"/"],[2,[3,"social_profile_id"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /reauthorize_social_profiles/:social_profile_id/:user_id/:id(.:format)
 * @param {any} social_profile_id
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_social_profile_path = /*#__PURE__*/ __jsr.r({"social_profile_id":{"r":true},"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reauthorize_social_profiles"],[2,[7,"/"],[2,[3,"social_profile_id"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reauthorize_social_profiles/:social_profile_id/:user_id(.:format)
 * @param {any} social_profile_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_social_profiles_url = /*#__PURE__*/ __jsr.r({"social_profile_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reauthorize_social_profiles"],[2,[7,"/"],[2,[3,"social_profile_id"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reauthorize_social_profiles/:social_profile_id/:user_id(.:format)
 * @param {any} social_profile_id
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_social_profiles_path = /*#__PURE__*/ __jsr.r({"social_profile_id":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reauthorize_social_profiles"],[2,[7,"/"],[2,[3,"social_profile_id"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_api_clients_assets_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_api_clients_assets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /activation_invitations/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_activation_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /activation_invitations/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_activation_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_account_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_account_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/ambassador_invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_ambassador_invite_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"ambassador_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/ambassador_invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_ambassador_invite_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"ambassador_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/ambassadors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_ambassadors_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"ambassadors"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/ambassadors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_ambassadors_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"ambassadors"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/facebook_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_facebook_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"facebook_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/facebook_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_facebook_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"facebook_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/instagram_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_instagram_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"instagram_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/instagram_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_instagram_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"instagram_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/jobs_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_jobs_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"jobs_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/jobs_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_jobs_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"jobs_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/linked_in_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_linked_in_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"linked_in_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/linked_in_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_linked_in_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"linked_in_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/linked_in_personal_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_linked_in_personal_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"linked_in_personal_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/linked_in_personal_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_linked_in_personal_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"linked_in_personal_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_root_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_root_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/social_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_social_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"social_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/social_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_social_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"social_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/twitter_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_twitter_dashboard_index_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"twitter_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/analytics/twitter_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_analytics_twitter_dashboard_index_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"twitter_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/hashtags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_asset_library_hashtag_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"hashtags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/hashtags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_asset_library_hashtag_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"hashtags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_asset_library_link_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_asset_library_link_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/text_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_asset_library_text_template_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"text_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/text_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_asset_library_text_template_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"text_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_assets_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_assets_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/brands(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_brands_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/brands(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_brands_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_calendar_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_calendar_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_campaigns_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_campaigns_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_company_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"company"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/company(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_company_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"company"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/company_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_company_report_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"company_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/company_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_company_report_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"company_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_home_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_home_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/image_edits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_image_edit_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"image_edits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/image_edits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_image_edit_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"image_edits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_integrations_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_integrations_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_map_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_map_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_maps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_maps_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_maps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_maps_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_postings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_posting_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_postings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_posting_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_postings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_postings_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_postings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_postings_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_source_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_source_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_sources_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_job_sources_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/lumina_video_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_lumina_video_imports_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"lumina_video_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/lumina_video_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_lumina_video_imports_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"lumina_video_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_posts_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_posts_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_root_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[1,[2,[8,"."],[3,"format"]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_root_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_account_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_account_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_accounts_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_accounts_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_group_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_group_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_groups/:social_profile_group_id/social_profiles/:id(.:format)
 * @param {any} social_profile_group_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_group_social_profile_url = /*#__PURE__*/ __jsr.r({"company_id":{},"social_profile_group_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_groups"],[2,[7,"/"],[2,[3,"social_profile_group_id"],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_groups/:social_profile_group_id/social_profiles/:id(.:format)
 * @param {any} social_profile_group_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_group_social_profile_path = /*#__PURE__*/ __jsr.r({"company_id":{},"social_profile_group_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_groups"],[2,[7,"/"],[2,[3,"social_profile_group_id"],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_groups_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_social_profile_groups_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/source_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_source_codes_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"source_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/source_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_source_codes_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"source_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_tags_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_tags_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/topic_post_ai_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_topic_post_ai_prompts_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"topic_post_ai_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/topic_post_ai_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_topic_post_ai_prompts_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"topic_post_ai_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/tracking_pixels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_tracking_pixels_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"tracking_pixels"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/tracking_pixels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_tracking_pixels_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"tracking_pixels"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_users_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const client_users_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:company_id/job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_job_postings_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /companies/:company_id/job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_job_postings_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies/:company_id/visual_job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_visual_job_postings_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"visual_job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /companies/:company_id/visual_job_postings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_visual_job_postings_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"visual_job_postings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /activation_invitations/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_activation_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /activation_invitations/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_activation_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /social_accounts/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_social_account_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /social_accounts/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_social_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/default_job_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_job_templates_admin_companies_url = /*#__PURE__*/ __jsr.r({"format":{"d":"xlsx"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"default_job_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/default_job_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_job_templates_admin_companies_path = /*#__PURE__*/ __jsr.r({"format":{"d":"xlsx"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"default_job_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /design_system/prototypes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_system_prototypes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"design_system"],[2,[7,"/"],[2,[6,"prototypes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /design_system/prototypes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_system_prototypes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"design_system"],[2,[7,"/"],[2,[6,"prototypes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /design_system(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_system_root_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"design_system"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /design_system(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const design_system_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"design_system"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ambassadors/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_ambassador_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_ambassador_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tags/destroy_unused(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_unused_api_clients_tags_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"destroy_unused"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tags/destroy_unused(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_unused_api_clients_tags_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"destroy_unused"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_clients_campaign_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_clients_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_clients_post_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_clients_post_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/publication_schedules/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_clients_publication_schedule_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/publication_schedules/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_api_clients_publication_schedule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/edit(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_brand_url = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/edit(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_company_brand_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/passwords/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ambassadors_passwords_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/passwords/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ambassadors_passwords_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ambassadors_users_url = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors(/:company_id)(/:ambassador_id)/users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ambassadors_users_path = /*#__PURE__*/ __jsr.r({"company_id":{},"ambassador_id":{},"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[1,[2,[7,"/"],[3,"ambassador_id"]]],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_job_source_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_job_source_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_post_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_post_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/publication_schedules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_publication_schedule_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/publication_schedules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_publication_schedule_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_group_schedules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_social_profile_group_schedule_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/social_profile_group_schedules/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_client_social_profile_group_schedule_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth/applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_oauth_application_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/oauth/applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/verifications/:token/edit(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_verification_url = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/verifications/:token/edit(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_verification_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /errors/internal_server_error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_internal_server_error_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"internal_server_error"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /errors/internal_server_error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_internal_server_error_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"internal_server_error"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /errors/not_found(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_not_found_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"not_found"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /errors/not_found(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const errors_not_found_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"errors"],[2,[7,"/"],[2,[6,"not_found"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ai_text_templates/export_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_templates_admin_ai_text_templates_url = /*#__PURE__*/ __jsr.r({"format":{"d":"xlsx"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai_text_templates"],[2,[7,"/"],[2,[6,"export_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ai_text_templates/export_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_templates_admin_ai_text_templates_path = /*#__PURE__*/ __jsr.r({"format":{"d":"xlsx"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ai_text_templates"],[2,[7,"/"],[2,[6,"export_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v1/ambassadors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_v1_ambassador_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v1/ambassadors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_v1_ambassador_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v1/ambassadors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_v1_ambassadors_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambassadors"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /v1/ambassadors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_v1_ambassadors_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ambassadors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_v1_posts_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /v1/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_v1_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets/facets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facets_api_clients_assets_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"facets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets/facets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facets_api_clients_assets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"facets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts/facets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facets_api_clients_posts_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"facets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts/facets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facets_api_clients_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"facets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tags/facets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facets_api_clients_tags_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"facets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tags/facets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facets_api_clients_tags_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"facets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /feeds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /feeds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feeds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /health_monitor
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_monitor_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"health_monitor"]], true);

/**
 * Generates rails route to
 * /health_monitor
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_monitor_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"health_monitor"]]);

/**
 * Generates rails route to
 * /health_monitor/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_monitor_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"health_monitor"]],[7,"/"]],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /health_monitor/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_monitor_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"health_monitor"]],[7,"/"]],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/job_posting_templates/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_client_asset_library_job_posting_templates_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"job_posting_templates"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/job_posting_templates/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_client_asset_library_job_posting_templates_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"job_posting_templates"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets/import_job_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_job_templates_api_clients_assets_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"import_job_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets/import_job_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_job_templates_api_clients_assets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"import_job_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /job_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_map_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /job_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_map_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /job_postings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_posting_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /job_postings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const job_posting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job_postings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_hashtag_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_hashtag_import_admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_hashtag_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_hashtag_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_hashtag_import_admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_hashtag_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_image_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_image_import_admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_image_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_image_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_image_import_admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_image_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_job_template_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_job_template_import_admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_job_template_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_job_template_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_job_template_import_admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_job_template_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_social_profile_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_social_profile_import_admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_social_profile_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/legacy_social_profile_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_social_profile_import_admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"legacy_social_profile_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lookbook
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"lookbook"]], true);

/**
 * Generates rails route to
 * /lookbook
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"lookbook"]]);

/**
 * Generates rails route to
 * /lookbook/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_home_url = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]], true);

/**
 * Generates rails route to
 * /lookbook/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_home_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]]);

/**
 * Generates rails route to
 * /lookbook/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /lookbook/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lookbook/pages/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_url = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"pages"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lookbook/pages/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_page_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"pages"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lookbook/previews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_previews_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"previews"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /lookbook/previews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_previews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"previews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lookbook/preview/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_preview_url = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"preview"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lookbook/preview/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_preview_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"preview"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lookbook/inspect/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_inspect_url = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"inspect"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lookbook/inspect/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_inspect_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"inspect"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lookbook/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_lookup_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /lookbook/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_lookup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lookbook/embed/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_url = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"embed"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lookbook/embed/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookbook_lookbook_embed_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"lookbook"]],[7,"/"]],[2,[6,"embed"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sources/:id/manual_queue(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_queue_api_clients_job_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manual_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sources/:id/manual_queue(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_queue_api_clients_job_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manual_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /material_colors/svgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const material_colors_svgs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"material_colors"],[2,[7,"/"],[2,[6,"svgs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /material_colors/svgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const material_colors_svgs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"material_colors"],[2,[7,"/"],[2,[6,"svgs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth(/:company_id)/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth(/:company_id)/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_company_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_company_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_url = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ambassadors/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ambassador_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ambassadors/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ambassador_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadors"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/activation_invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_activation_invitation_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/activation_invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_activation_invitation_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/assets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_asset_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/assets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_asset_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/brands/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_brand_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/brands/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_brand_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_campaign_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_campaign_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_job_source_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_job_source_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_post_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_post_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/source_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_source_code_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/source_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_source_code_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_user_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_clients_user_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/asset_source_imports/:asset_source_id/new(.:format)
 * @param {any} asset_source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_asset_source_import_url = /*#__PURE__*/ __jsr.r({"company_id":{},"asset_source_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"asset_source_imports"],[2,[7,"/"],[2,[3,"asset_source_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/asset_source_imports/:asset_source_id/new(.:format)
 * @param {any} asset_source_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_asset_source_import_path = /*#__PURE__*/ __jsr.r({"company_id":{},"asset_source_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"asset_source_imports"],[2,[7,"/"],[2,[3,"asset_source_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/embedded_videos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_embedded_video_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"embedded_videos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/embedded_videos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_embedded_video_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"embedded_videos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/employer_brand_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_employer_brand_template_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"employer_brand_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/employer_brand_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_employer_brand_template_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"employer_brand_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_image_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_image_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/job_posting_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_job_posting_template_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"job_posting_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/job_posting_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_job_posting_template_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"job_posting_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/job_summary_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_job_summary_template_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"job_summary_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/job_summary_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_job_summary_template_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"job_summary_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_link_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_link_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/magic_post_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_magic_post_template_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"magic_post_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/asset_library/magic_post_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_asset_library_magic_post_template_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"asset_library"],[2,[7,"/"],[2,[6,"magic_post_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/image_edits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_image_edit_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"image_edits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/image_edits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_image_edit_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"image_edits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_job_source_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_job_source_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_post_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_post_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/publication_schedules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_publication_schedule_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/publication_schedules/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_client_publication_schedule_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /material_colors/svgs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_material_colors_svg_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"material_colors"],[2,[7,"/"],[2,[6,"svgs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /material_colors/svgs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_material_colors_svg_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"material_colors"],[2,[7,"/"],[2,[6,"svgs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /material_colors/themes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_material_colors_theme_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"material_colors"],[2,[7,"/"],[2,[6,"themes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /material_colors/themes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_material_colors_theme_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"material_colors"],[2,[7,"/"],[2,[6,"themes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth/applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_application_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/oauth/applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_application_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/social_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_sqrl_social_account_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/social_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_sqrl_social_account_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_application_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/oauth/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/oauth/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/oauth/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth(/:company_id)/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth(/:company_id)/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth(/:company_id)/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth(/:company_id)/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth(/:company_id)/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth(/:company_id)/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth(/:company_id)/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth(/:company_id)/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth(/:company_id)/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_info_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth(/:company_id)/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_info_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_posting_metrics/other_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const other_applications_api_clients_job_posting_metrics_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_posting_metrics"],[2,[7,"/"],[2,[6,"other_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_posting_metrics/other_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const other_applications_api_clients_job_posting_metrics_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_posting_metrics"],[2,[7,"/"],[2,[6,"other_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/job_sources/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_job_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/job_sources/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_job_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/posts/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_posts_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/posts/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_posts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/publication_schedules/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_publication_schedules_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/publication_schedules/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_publication_schedules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"publication_schedules"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_profile_group_schedules/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_social_profile_group_schedules_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_profile_group_schedules/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_clients_social_profile_group_schedules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_profile_group_schedules"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_client_job_source_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /client(/:company_id)/job_sources/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_client_job_source_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"client"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"job_sources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_component_url = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/view_components/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_component_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/view_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_components_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails/view_components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_view_components_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"view_components"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_url = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /api/clients/source_codes/sample_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sample_url_api_clients_source_codes_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[2,[7,"/"],[2,[6,"sample_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/source_codes/sample_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sample_url_api_clients_source_codes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"source_codes"],[2,[7,"/"],[2,[6,"sample_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/activation_invitations/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_activation_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/activation_invitations/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_activation_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"activation_invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/social_accounts/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_social_account_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/social_accounts/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_social_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/tracking_pixels/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_tracking_pixel_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tracking_pixels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/tracking_pixels/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_tracking_pixel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"tracking_pixels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/users/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/users/:id/send_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_email_api_clients_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]], true);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_account_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /social_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"social_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sqrl_publication_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/publications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sqrl_publication_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"publications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/social_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sqrl_social_accounts_url = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/social_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sqrl_social_accounts_path = /*#__PURE__*/ __jsr.r({"company_id":{},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sqrl_social_profile_url = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /sqrl(/:company_id)/social_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sqrl_social_profile_path = /*#__PURE__*/ __jsr.r({"company_id":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sqrl"],[2,[1,[2,[7,"/"],[3,"company_id"]]],[2,[7,"/"],[2,[6,"social_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/clients/campaigns/:campaign_id/assets/summary(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_clients_campaign_assets_url = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/campaigns/:campaign_id/assets/summary(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_clients_campaign_assets_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /systems/health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systems_health_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /systems/health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systems_health_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /systems/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systems_ping_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /systems/ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const systems_ping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"systems"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /test-error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_error_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"test-error"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /test-error(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_error_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"test-error"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/clients/metrics/top_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_posts_api_clients_metrics_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"top_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/clients/metrics/top_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const top_posts_api_clients_metrics_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[6,"top_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/tracking_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tracking_events_admin_company_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"csv"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tracking_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/tracking_events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tracking_events_admin_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"csv"},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tracking_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /t/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tracking_pixel_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /t/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tracking_pixel_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_user_confirmation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/google/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/microsoft_office365(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_office365_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_office365"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/microsoft_office365(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_office365_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_office365"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/microsoft_office365/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_office365_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_office365"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/microsoft_office365/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_office365_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_office365"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/okta(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_okta_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"okta"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/okta(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_okta_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"okta"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/okta/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_okta_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"okta"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/okta/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_okta_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"okta"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/:provider/initiate(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_omniauth_initiate_url = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"initiate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/:provider/initiate(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_omniauth_initiate_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"initiate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/verifications/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_verification_url = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/verifications/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_verification_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

